export enum INT_EXT_OPTIONS {
	Interior = 1,
	Exterior = 2,
	IntExt = 3,
	ExtInt = 4
}

export enum DAY_NIGHT_OPTIONS {
	Day = 1,
	Night = 2,
	Sunrise = 3,
	Sunset = 4,
}

export enum SCENE_STATUS {
	PreBreakdown = 1,
	Private = 2,
	NotAssigned = 3,
	Assigned = 4,
	Produced = 5,
	ProducedAssigned = 6,
	Retake = 7,
	Cancel = 8
}